<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="administrators"
            :items="tableData"
            :fields="internshipFields">
            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-circle-check btn-accept-internship"
                        v-b-tooltip.hover
                        variant="success-icon-only"
                        :title="$t('internship.accept')"
                        @click="acceptInternship(data.item.id)">
                    </b-button>
                    <!--                    <b-button class="btn-circle-times btn-remove-internship"-->
                    <!--                              title="Verwerpen"-->
                    <!--                              v-b-tooltip.hover-->
                    <!--                              variant="danger-icon-only"-->
                    <!--                              @click="removeInternship(data.item.id)">-->
                    <!--                    </b-button>-->
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internships-index-extern-tab-component',
    props: ['internshipsIn'],
    data() {
        return {
            internships: this.internshipsIn,
            internshipFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'location',
                    label: this.$t('common.location'),
                },
                {
                    key: 'slots',
                    label: this.$t('internship.amount_of_places'),
                },
                {
                    key: 'tags',
                    label: this.$t('internship.internship_type'),
                },
                {
                    key: 'owner',
                    label: this.$t('internship.of'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.internshipsIn.map((internship) => {
                return {
                    id: internship.id,
                    name: internship.name,
                    location: internship.location,
                    slots: internship.slots,
                    owner: internship.internship_ownerable.name,
                    tags: internship.internship_tags.map((tag) => tag.name).join(', '),
                };
            });
        },
    },
    methods: {
        acceptInternship(id) {
            this.alert
                .confirm(
                    this.$t('internship.accept_internship'),
                    this.$t('internship.are_you_sure_you_want_to_accept_this_internship_place'),
                    this.$t('common.confirm'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.axios.post(this.routes.internshipAcceptExternal(id)).then(
                        (response) => {
                            this.alert.success();
                            this.$emit('acceptInternship', id);
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;
    flex-direction: row;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
    align-items: center;

    button {
        &:before {
            margin-right: 0;
        }
    }
}
</style>
